import { ExpertTime } from "./expert-time.model";

export class ExpertTimeList {
    dayOfWeek: string;
    month: string;
    date: string;
    availableTimes: ExpertTime[] = [];
}